import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { SPEACH_PAGE_PATH } from "Routes/paths";

const SpeechOfTheCEO = () => {
  const { t, i18n } = useTranslation();
  return (
    <section className="my-[100px] lg:my-[90px] w-full  flex items-center justify-center">
      <div className="mainContainer w-full h-full px-[30px] lg:px-0 flex flex-col gap-4">
        <div
          data-aos="fade-up"
          data-aos-duration="1000"
          className="p-[50px] min-h-[400px] lg:h-full bg-home_55 bg-cover lg:bg-home_2 lg:bg-cover rounded-[15px] flex "
        >
          <div className="hidden lg:flex flex-col items-center lg:items-start justify-center gap-4">
            {" "}
            <p
              className={`font-${
                i18n.language === "en" ? "Poppins" : "Almarai"
              } font-[700] text-[18px] lg:text-[32px] text-white lg:text-left text-center`}
            >
              {t("The Speech of The CEO")}
            </p>
            <p
              className={`max-w-[470px] ${
                i18n.language === "en"
                  ? "font-Poppins lg:text-left"
                  : "font-Almarai lg:text-right"
              } font-[600] text-[12px] lg:text-[16px] text-white lg:text-left text-center opacity-0 lg:opacity-100`}
            >
              {t(
                "Over the long years of sincere and serious humanitarian work for this national humanitarian edifice, successive generations in this Al-Ittihad Charitable Foundation..."
              )}
            </p>
            <Link
              to={`${SPEACH_PAGE_PATH}`}
              className={`w-[150px] h-[40px] rounded-[10px] bg-white text-first_color text-[13px] font-${
                i18n.language === "en" ? "Poppins" : "Almarai"
              } font-[600] hover:bg-first_color hover:text-white duration-300 flex items-center justify-center`}
            >
              {t("Read More")}
            </Link>
          </div>
        </div>

        {/* mobile view only  */}
        <div className="lg:hidden flex flex-col gap-3">
          {" "}
          <p
            className={`font-${
              i18n.language === "en" ? "Poppins" : "Almarai"
            } font-[700] text-[18px] lg:text-[32px] text-second_color lg:text-left text-center`}
          >
            {t("The Speech of The CEO")}
          </p>
          <p
            className={`max-w-[470px] ${
              i18n.language === "en"
                ? "font-Poppins lg:text-left"
                : "font-Almarai lg:text-right"
            } font-[600] text-[12px] lg:text-[16px] text-second_color lg:text-left text-center `}
          >
            {t(
              "Over the long years of sincere and serious humanitarian work for this national humanitarian edifice, successive generations in this Al-Ittihad Charitable Foundation..."
            )}
          </p>
          <div className="flex flex-col items-center justify-center">
            <Link
              to={`${SPEACH_PAGE_PATH}`}
              className={`w-[150px] h-[40px] rounded-[10px] bg-first_color text-white text-[13px] font-${
                i18n.language === "en" ? "Poppins" : "Almarai"
              } font-[600] flex items-center justify-center`}
            >
              {t("Read More")}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpeechOfTheCEO;
